import { apiSlice } from 'app/api/apiSlice'
import { removeEmptyKeys } from 'utilities'

export const sgeApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSGE: builder.query({
            query: ({ page, limitNumber, params }) => {
                return {
                    url: `/bouser/sge/${page}/params`,
                    params: { limitNumber, ...removeEmptyKeys(params) },
                }
            },
            transformResponse: (response, meta, args) => {
                let parsedSGE = response.result.map((tsge) => {
                    return {
                        ...tsge
                    }
                })
                return {
                    rows: parsedSGE,
                    count: response.count,
                    pages: response.pages,
                }
            },
            providesTags: ['bouser'],
        })
    }),
    overrideExisting: true,
})

export const {
    useGetSGEQuery
} = sgeApiSlice
